import React, { useRef, useState } from "react";
import Navbar from "../../components/Navbar";
import Reset_Password from "../../assets/auth/reset-password.png";
import Close_Button from "../../assets/auth/close.png";
import Styles from "../../styles/coach/changeemail.module.scss";
import { changeCoachEmailService } from "../../services";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import { setCoachLogout, toggle } from "../../redux";
import { coachRoutes } from "../../routers/CoachRouters";
import { Link, useNavigate } from "react-router-dom";

const ChangeEmail = () => {
  const navigate = useNavigate();
  let currentEmailRef = useRef("");
  let newEmailRef = useRef("");
  const isSidebarOpen = useSelector((state) => state.navbar.button);

  const [currentEmail, setCurrentEmail] = useState("");
  const [newEmail, setNewEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const dispatch = useDispatch();
  const handleMainContainerClick = () => {
    if (isSidebarOpen) {
      dispatch(toggle());
    }
  };
  const handleLogout = async () => {
    dispatch(setCoachLogout());
    navigate(coachRoutes.login);
  };

  const handleCancel = () => {
    navigate(-1); // Go back to previous page
  };

  // Email validation function
  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // Current email change handler
  const handleCurrentEmailChange = (e) => {
    const value = e.target.value;
    setCurrentEmail(value);
    currentEmailRef.current.value = value;

    // Clear any existing errors when user starts typing
    if (emailError) {
      setEmailError("");
    }
  };

  // New email change handler with validation
  const handleNewEmailChange = (e) => {
    const value = e.target.value;
    setNewEmail(value);
    newEmailRef.current.value = value;

    // Validate email format
    if (value && !isValidEmail(value)) {
      setEmailError("Please enter a valid email address");
    } else if (value && currentEmail && value === currentEmail) {
      setEmailError("New email must be different from current email");
    } else {
      setEmailError("");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate email format
    if (!isValidEmail(newEmail)) {
      setEmailError("Please enter a valid email address");
      return;
    }

    // Check if emails are the same
    if (currentEmail === newEmail) {
      setEmailError("New email must be different from current email");
      return;
    }

    // Clear any existing email errors
    setEmailError("");

    // Send only the new email
    const success = await changeCoachEmailService(newEmail);

    if (success) {
      Swal.fire({
        html: `
          <div style="text-align: center; border-radius: 20px; position: relative; font-family: 'gothambold', sans-serif;">
            <button 
              id="customCloseButton" 
              style="position: absolute; top: -10px; right: -20px; background: none; border: none; cursor: pointer;">
              <img 
                src=${Close_Button} 
                alt="Close" 
                style="width: 50px; height: 50px;"
              />
            </button>
            <img 
              src=${Reset_Password} 
              alt="Success" 
              style="width: 100px; margin-bottom: 20px; margin-top: 30px;" 
            />
            <h2 style="margin: 0; font-family: 'gothambold', sans-serif;">Email Changed!</h2>
            <br/>
            <p style="font-family: 'Gotham Book', sans-serif;">
              You've successfully updated your email address.
            </p>
            <br/>
            <button 
              id="okButton" 
              style="
                background: linear-gradient(0deg, #151515 0%, #525252 100%); 
                color: #f3f3f6; 
                padding: 10px 30px; 
                border: none; 
                border-radius: 5px; 
                cursor: pointer; 
                margin-top: 20px; 
                font-family: 'gothambold', sans-serif;
              ">
              Continue
            </button>
          </div>
        `,
        showConfirmButton: false,
        customClass: {
          popup: "custom-swal-container",
        },
        didOpen: () => {
          const thanksButton = document.getElementById("okButton");
          thanksButton.addEventListener("click", () => {
            Swal.close();
            navigate(-1);
          });
        },
      });
    }
  };

  return (
    <>
      <Navbar />
      <div
        className={Styles.exercise_list_container_main}
        onClick={handleMainContainerClick}
      >
        <h2>
          <Link to={coachRoutes.dashboard}>HOME / </Link>
          <Link to={coachRoutes.viewProfile}> PROFILE / </Link>
          <span>CHANGE EMAIL</span>
        </h2>

        <div className={Styles.exercise_list_container}>
          <div className={Styles.table_container_heading}>
            <div className={Styles.table_container_headingone}>
              <h3>CHANGE EMAIL</h3>
            </div>
          </div>

          <div className={Styles.borderbottomline}></div>

          <div className={Styles.renderedcontentmaindiv}>
            <form
              className={Styles.profile_form}
              autoComplete="off"
              onSubmit={handleSubmit}
            >
              <div className={Styles.form_grid}>
                {/* Current Email Field */}
                <div className={Styles.form_field}>
                  <label className={Styles.field_label}>Current Email</label>
                  <input
                    className={Styles.form_input}
                    placeholder="Enter your current email"
                    name="currentEmail"
                    type="email"
                    ref={currentEmailRef}
                    onChange={handleCurrentEmailChange}
                    required
                  />
                </div>

                {/* New Email Field */}
                <div className={Styles.form_field}>
                  <label className={Styles.field_label}>New Email</label>
                  <input
                    className={`${Styles.form_input} ${
                      emailError ? Styles.error_input : ""
                    }`}
                    placeholder="Enter your new email"
                    name="newEmail"
                    type="email"
                    ref={newEmailRef}
                    onChange={handleNewEmailChange}
                    required
                  />
                  {emailError && (
                    <div className={Styles.error_message}>{emailError}</div>
                  )}
                </div>
              </div>

              <div className={Styles.borderbottomline}></div>

              {/* Button Group */}
              <div className={Styles.button_group}>
                <button type="submit" className={Styles.save_button}>
                  Submit
                </button>
                <button
                  type="button"
                  className={Styles.cancel_button}
                  onClick={handleCancel}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChangeEmail;
